import HolacracyMark from 'assets/icons/holacracyMark.svg'

export default HolacracyMark
